import API from "../../actions";
import moment from "moment";
import { getDKTimeRange, getDKDateTimeRange, getDKtimeText } from "../../libs/dktime";

export const getBookings = async (start, end) => {
    const bookingsWithDuplicate = await API.getBookingsFromTherapist(start, end);
    const bookingsMap = {};
    const bookings = [];
    bookingsWithDuplicate.forEach(booking => {
        if (bookingsMap[booking.id]) return;
        bookingsMap[booking.id] = true;
        bookings.push(booking);
    });
    return await Promise.all(
        bookings.map(async booking => {
            const fullName = booking.nameFirst && booking.nameLast ? booking.nameFirst + " " + booking.nameLast : null;
            return Object.assign(
                {
                    title: /*getDKTimeRange(booking.from, booking.to) + */ fullName,
                    orgTitle: fullName,
                    dkTime: getDKDateTimeRange(booking.from, booking.to),
                    description: booking.treatmentName,
                    reason: booking.reason,
                    start: await moment(new Date(Number(booking.from))).format("YYYY-MM-DDTHH:mm:ss"),
                    end: await moment(new Date(Number(booking.to))).format("YYYY-MM-DDTHH:mm:ss"),
                    invoiceId: booking.invoiceId,
                    firstBooking: booking.firstBooking,
                    textColor: "#343434",

                    bookingId: booking.id,
                    journalId: booking.journalId,
                    clientId: booking.clientId,
                    treatmentId: booking.treatmentId,
                    profileImage: booking.profileImage,
                    profileImageOnGoogle: booking.profileImageOnGoogle,
                    email: booking.email
                },
                booking.journalId || (booking.hasStamjournal && booking.firstBooking)
                    ? {
                          backgroundColor: "#90eab7",
                          borderColor: "#90eab7"
                      }
                    : {
                          backgroundColor: "#f8d560",
                          borderColor: "#f8d560"
                      },
                booking.invoiceId
                    ? {
                          backgroundColor: "#4d5ccc",
                          borderColor: "#4d5ccc"
                      }
                    : "",
                !booking.treatmentId && {
                    backgroundColor: "red",
                    borderColor: "red",
                    textColor: "white"
                }
            );
        })
    );
};

// export const getOpeningHours = async (from, to) => {
//     const bookings = await API.getOpeningHoursFromTherapist(from, to);
//     bookings.push({ from: from, to: from });
//     return await Promise.all(
//         bookings.map(async booking => {
//             return Object.assign({
//                 id: "bgId",
//                 start: await moment(new Date(Number(booking.from))).format("YYYY-MM-DDTHH:mm:ss"),
//                 end: await moment(new Date(Number(booking.to))).format("YYYY-MM-DDTHH:mm:ss"),
//                 editable: false,
//                 rendering: "inverse-background",
//                 backgroundColor: "#f4f4f4",
//                 borderColor: "#f4f4f4",
//                 textColor: "#000"
//             });
//         })
//     );
// // };
// export const getOpeningHours = async (from, to) => {
//     const bookings = await API.getOpeningHoursFromTherapist(from, to);
//     bookings.push({ from: from, to: from });

//     return bookings.map(booking => ({
//         id: `bgId-${booking.from}-${booking.to}`, // unique id
//         start: moment(Number(booking.from)).format("YYYY-MM-DDTHH:mm:ss"),
//         end: moment(Number(booking.to)).format("YYYY-MM-DDTHH:mm:ss"),
//         editable: false,
//         display: "inverse-background", // correct property for FullCalendar v5+
//         backgroundColor: "#fff",
//         borderColor: "#fff",
//         textColor: "#000",
//     }));
// };

// export const getOpeningHours = async (from, to) => {
//     const bookings = await API.getOpeningHoursFromTherapist(from, to);
//     bookings.push({ from: from, to: from });
//     return await Promise.all(
//         bookings.map(async booking => {
//             return Object.assign({
//                 id: "bgId",
//                 start: await moment(new Date(Number(booking.from))).format("YYYY-MM-DDTHH:mm:ss"),
//                 end: await moment(new Date(Number(booking.to))).format("YYYY-MM-DDTHH:mm:ss"),
//                 editable: false,
//                 rendering: "inverse-background",
//                 backgroundColor: "#f4f4f4",
//                 borderColor: "#f4f4f4",
//                 textColor: "#000"
//             });
//         })
//     );
// // };
// export const getOpeningHours = async (from, to) => {
//     const bookings = await API.getOpeningHoursFromTherapist(from, to);
//     bookings.push({ from: from, to: from });

//     return bookings.map(booking => ({
//         id: `bgId-${booking.from}-${booking.to}`, // unique id
//         start: moment(Number(booking.from)).format("YYYY-MM-DDTHH:mm:ss"),
//         end: moment(Number(booking.to)).format("YYYY-MM-DDTHH:mm:ss"),
//         editable: false,
//         display: "inverse-background", // correct property for FullCalendar v5+
//         backgroundColor: "#fff",
//         borderColor: "#fff",
//         textColor: "#000",
//     }));
// };

export const getOpeningHours = async (from, to) => {
    const bookings = await API.getOpeningHoursFromTherapist(from, to);

    // Parse all dates from `from` to `to` into a list of dates (days)
    const allDates = getAllDatesBetween(new Date(Number(from)), new Date(Number(to)));

    // Add full-day gray blocks for each date
    const backgroundDefaults = allDates.map(date => {
        const dayStr = moment(date).format("YYYY-MM-DD");
        return {
            id: `bg-default-${dayStr}`,
            start: `${dayStr}T00:00:00`,
            end: `${dayStr}T24:00:00`,
            display: "background",
            backgroundColor: "gray",
            borderColor: "gray"
        };
    });

    // Add white blocks for open hours
    const openHourBlocks = bookings.map(booking => ({
        id: `bg-${booking.from}`,
        start: moment(Number(booking.from)).format("YYYY-MM-DDTHH:mm:ss"),
        end: moment(Number(booking.to)).format("YYYY-MM-DDTHH:mm:ss"),
        display: "background",
        backgroundColor: "#fff",
        borderColor: "#fff"
    }));

    return [...backgroundDefaults, ...openHourBlocks];
};

// Utility function to get all dates between from and to
const getAllDatesBetween = (from, to) => {
    const dates = [];
    const current = new Date(from);
    while (current <= to) {
        dates.push(new Date(current));
        current.setDate(current.getDate() + 1);
    }
    return dates;
};

export const getCourses = async (from, to) => {
    let courses = await API.getEventsFromTherapist();
    const dates = await API.getEventDatesFromTherapist();
    const coursesMap = {};
    courses.forEach(course => {
        coursesMap[course.id] = course;
        coursesMap[course.id].dates = [];
    });
    dates.forEach(date => {
        if (date.to < from || date.from > to) return;
        coursesMap[date.eventId].dates.push(date);
    });
    courses = courses.map(course => coursesMap[course.id]);

    return courses.map(course => {
        return course.dates.map(date => {
            const d1 = new Date(parseInt(date.from));
            const d2 = new Date(parseInt(date.to));
            return Object.assign({
                id: date.id,
                limit: course.limit,
                editable: false,
                title: getDKTimeRange(+date.from, +date.to) + course.title,
                orgTitle: course.title,
                dkTime: getDKtimeText(+date.from),
                desc: course.description,
                description: "",
                start: d1,
                end: d2,
                textColor: "#343434",
                backgroundColor: "#DC7F9E",
                borderColor: "#DC7F9E"
            });
        });
    });
};
